export default __webpack_public_path__ + "static/media/mobile.1e512ef3.svg";